export enum Role {
  CorporateSales = 'Corporate_Sales',
  Corporate = 'Corporate',
  Dealer = 'Dealer',
  DealerAdmin = 'DealerAdmin',
  DealerCorporateAdmin = 'DealerCorporateAdmin',
  DealerEmulateAll = 'Dealer Emulate All',
  DealerEmulateAllOkta = 'Corporate_Emulation',
  DealerEmulateAllReadOnlyOkta = 'Corporate_Sales',
  DealerEmulation = 'Dealer Emulation',
  FIManager = 'FIManager',
  Finance = 'Finance',
  Maintenance = 'Maintenance',
  SalesRep = 'SalesRep',
  BackOffice = 'BackOffice',

  QAAdmin = 'QAAdmin',
  ADM = 'ADM',
  Emulate = 'Emulate',
  ROShop = 'RO Shop',
  RORegister = 'RO Register',
}
